<template>
  <div class="mt-10 mb-10 border-t-sm pt-6">
    <h2 class="mb-4">Renewals</h2>
    <SoAlert
      v-if="renewalsQuery.isError"
      title="Failed to render renewals for user"
      data-testid="renewals-list-error"
    />
    <SoDataTable
      v-else
      data-testid="renewals-list-table"
      :headers="renewalsTableHeaders"
      :items="tableData"
      :loading="renewalsQuery.isFetching"
      :searchable="false"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDataTable from "@/components/dataTable/SoDataTable.vue"
  import SoAlert from "@/components/SoAlert.vue"
  import {
    SoDataTableColumnType,
    SoDataTableHeader,
  } from "@/types/components/SoDataTable"
  import { getRenewalsForUser } from "@/services-handlers/getRenewalsForUser"

  const headers: SoDataTableHeader[] = [
    {
      title: "ID",
      key: "id",
    },
    {
      title: "Renewal Date",
      key: "createdAt",
      type: SoDataTableColumnType.DATE,
    },
    {
      title: "Uploaded at",
      key: "uploadedAt",
      type: SoDataTableColumnType.DATE,
    },
    {
      title: "Meterpoints",
      key: "meterpoints",
    },
  ]

  export default defineComponent({
    components: {
      SoAlert,
      SoDataTable,
    },
    data() {
      return {
        renewalsQuery: getRenewalsForUser(Number(this.$route.params.userId)),
        renewalsTableHeaders: headers,
      }
    },
    computed: {
      tableData() {
        const { data } = getRenewalsForUser(Number(this.$route.params.userId))
        return data.map((renewal) => ({
          ...renewal,
          meterpoints: renewal.meterpointIdentifiers.join(", "),
        }))
      },
    },
  })
</script>
